import * as _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class LodashUtil {

  static cloneDeep = (data: any) => _.cloneDeep(data);

  static clone = (data: any) => _.clone(data);

  static sortBy = (data: any, key: string | string[]) => _.sortBy(data, key);

  static randomDigit(length: number = 5): string {
    const char = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return _.sampleSize(char, length).join('');
  }

}